export default __webpack_public_path__ + "static/media/app-mockup.be6cb710.png";